// ---------------------------------------------------------------------------
// Interrupteurs de fonctionnalités (feature flags) — front BeTravel
// ---------------------------------------------------------------------------

/**
 * Paiement en ligne (SumUp).
 *
 * - `false` (par défaut) : le tunnel de paiement est DÉSACTIVÉ. À la fin d'un
 *   formulaire ou depuis le menu des demandes, le client « lance sa demande » :
 *   on enregistre son adresse de facturation et on bascule le dossier en
 *   traitement (même logique que les clients société), SANS rediriger vers la
 *   page de paiement SumUp.
 * - `true` : on rebranche le tunnel de paiement SumUp (comportement historique).
 *
 * Pour réactiver le paiement, il suffit de repasser ce flag à `true` ICI **et**
 * de mettre `PAIEMENT_ACTIF=true` dans le `.env` du backend (`betravel-backend`).
 * Tout le code SumUp (front + back) est conservé intact, simplement contourné.
 */
export const PAIEMENT_ACTIF = false;
